import { Button ,Spinner} from "react-bootstrap";
import React,{ useState, useEffect } from "react";
import { api_url } from "../../constant/constant";
import { useTranslation } from 'react-i18next';
import { showToast } from "../ShowToast/ToastNotification";

const EditEmail = ({ id }) => {
    const [isLoading, setIsLoading] = useState(false); // Loader state

    const { t } = useTranslation();
    const [userId] = useState(id);
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };


    const [formData, setFormData] = useState({
        name: "",
        username: "",
        password: "",
        port: "",
        encryption: "",
        host: "",
        mail_from_address:"",
        mail_from_name:"",
        is_for_password_reset:"0"


    });

    const fetchEmailData = async () => {
        try {
            const token = localStorage.getItem("userToken");
    
            const response = await fetch(`${api_url}/email-servers/${userId}`, {
                mode: 'cors',
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                }
            });
    
            if (!response.ok) {
                showToast(t("errorFetchingEmail"), "error");
                return;
            }
    
            const result = await response.json();
            const emailData = result.data; // Access the `data` field from response
    
            setFormData({
                ...formData,
                name: emailData.name,
                username: emailData.username,
                password: emailData.password,
                port: emailData.port,
                host: emailData.host,
                encryption: emailData.encryption,
                mail_from_address: emailData.mail_from_address,
                mail_from_name: emailData.mail_from_name,
                  is_for_password_reset: emailData.is_for_password_reset === 1 ? "1" : "0"

            });
    
    
        } catch (err) {
            console.error("Fetch error:", err);
            showToast(t("errorFetchingEmail"), "error");
        }
    };
    

    useEffect(() => {
        fetchEmailData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleEditEmail = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Loader start

        console.log(formData);

        try {
            const token = localStorage.getItem("userToken");
            const response = await fetch(api_url + "/email-servers/" + userId, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
                redirect: "follow"
            });

            if (response.ok) {
                showToast(t("emailServerUpdatedSuccess"), "success");
                handleClose();
              } else {
                showToast(t("failedToUpdateEmailServer"), "error");
                handleClose();
              }
              } catch (error) {
                showToast(t("somethingWentWrongRefresh"), "error");
                handleClose();
              }finally {
            setIsLoading(false); // Loader stop
        }
    }

    return (
        <div className="py-4"  style={{border:'1px solid #EAEAEA',borderRadius:'10px',padding:'0px 15px'}}>


            <div className="row">
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">{t('Name')}</label>
                        <input type="text" name="name" className="form-control" onChange={handleChange} value={formData.name} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">{t('Username')}</label>
                        <input type="email" name="username" className="form-control" onChange={handleChange} value={formData.username} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">{t('Password')}</label>
                        <input type="password" name="password" className="form-control" onChange={handleChange} value={formData.password} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">{t('Host')}</label>
                        <input type="host" name="host" className="form-control" onChange={handleChange} value={formData.host} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">{t('Port')}</label>
                        <input type="text" name="port" className="form-control" onChange={handleChange} value={formData.port} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">{t('Encryption')}</label>
                        <input type="encryption" name="encryption" className="form-control" onChange={handleChange} value={formData.encryption} required />
                    </div>
                </div>
                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">{t('Mail From Address')}</label>
                                            <input type="email" name="mail_from_address" className="form-control" onChange={handleChange} value={formData.mail_from_address} required />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">{t('Mail From Name')}</label>
                                            <input type="text" name="mail_from_name" className="form-control" onChange={handleChange} value={formData.mail_from_name} required />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-check">
                                <input
                                        style={{ marginLeft: "0px" }}
                                        type="checkbox"
                                        name="is_for_password_reset"
                                        className="form-check-input"
                                        checked={formData.is_for_password_reset === "1"}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                is_for_password_reset: e.target.checked ? "1" : "0",
                                            })
                                        }
                                    />


                                        <label className="form-check-label ms-2">{t('PasswordReset')}</label>
                                    </div>

                <div className="col-md-6">
                    <div className="mb-3">
                    </div>
                </div>
            </div>
            <button 
                type="submit" 
                className="btn btn-primary" 
                disabled={isLoading} 
                onClick={handleEditEmail}  // <-- Add this line
            >
                {isLoading ? (
                    <>
                        <Spinner animation="border" size="sm" role="status" className="me-2" />
                        {t('Update...')}
                    </>
                ) : (
                    t('UpdateEmailServer')
                )}
            </button>

        </div>
    );

}

export default EditEmail;